(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Giveaway countdown (Sorteo): plain interval tick, not tied to
  // scroll or reduced-motion (it's a clock, not decorative motion). ----------
  var countdownEl = document.querySelector('[data-bc-countdown]');
  if (countdownEl) {
    var targetRaw = countdownEl.getAttribute('data-target');
    var target = targetRaw ? new Date(targetRaw).getTime() : NaN;
    var daysEl = countdownEl.querySelector('[data-bc-countdown-days]');
    var hoursEl = countdownEl.querySelector('[data-bc-countdown-hours]');
    var minutesEl = countdownEl.querySelector('[data-bc-countdown-minutes]');
    var secondsEl = countdownEl.querySelector('[data-bc-countdown-seconds]');
    var endedEl = document.querySelector('[data-bc-countdown-ended]');
    var pad = function (n) {
      return n < 10 ? '0' + n : '' + n;
    };

    var tickCountdown = function () {
      var diff = target - Date.now();
      if (isNaN(target) || diff <= 0) {
        countdownEl.hidden = true;
        if (endedEl) endedEl.hidden = false;
        clearInterval(countdownTimer);
        return;
      }
      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((diff / (1000 * 60)) % 60);
      var seconds = Math.floor((diff / 1000) % 60);
      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    };

    tickCountdown();
    var countdownTimer = setInterval(tickCountdown, 1000);
  }

  // ---------- Horizontal swipeable strips (Resultados photos, Cómo trabajo
  // steps): arrow buttons scroll by one item; hide an arrow at either end.
  // Runs regardless of reduced-motion (it's navigation, not decoration). ----------
  var initHScrollArrows = function (trackAttr, wrapClass, prevAttr, nextAttr) {
    document.querySelectorAll(trackAttr).forEach(function (track) {
      var wrap = track.closest(wrapClass);
      if (!wrap) return;
      var prev = wrap.querySelector(prevAttr);
      var next = wrap.querySelector(nextAttr);
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;

      var scrollByItem = function (direction) {
        var item = track.firstElementChild;
        var amount = item ? item.getBoundingClientRect().width + gap : 300;
        track.scrollBy({ left: direction * amount, behavior: reduced ? 'auto' : 'smooth' });
      };

      var updateArrows = function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (prev) prev.hidden = track.scrollLeft <= 4;
        if (next) next.hidden = track.scrollLeft >= maxScroll - 4;
      };

      if (next) {
        next.addEventListener('click', function () {
          scrollByItem(1);
        });
      }
      if (prev) {
        prev.addEventListener('click', function () {
          scrollByItem(-1);
        });
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    });
  };

  initHScrollArrows(
    '[data-bc-case-photos]',
    '.bc-result-case__photos-wrap',
    '[data-bc-case-photos-prev]',
    '[data-bc-case-photos-next]'
  );
  initHScrollArrows(
    '[data-bc-how-steps]',
    '.bc-how__steps-wrap',
    '[data-bc-how-steps-prev]',
    '[data-bc-how-steps-next]'
  );

  // ---------- Lightbox: click any result-case photo to view it enlarged. ----------
  var lightbox = document.querySelector('[data-bc-lightbox]');
  if (lightbox) {
    var lightboxImg = lightbox.querySelector('[data-bc-lightbox-img]');
    var lightboxClose = lightbox.querySelector('[data-bc-lightbox-close]');

    var openLightbox = function (img) {
      if (img && lightboxImg) {
        lightboxImg.src = img.currentSrc || img.src;
        lightboxImg.alt = img.alt || '';
      }
      lightbox.hidden = false;
    };
    var closeLightbox = function () {
      lightbox.hidden = true;
    };

    document.querySelectorAll('[data-bc-lightbox-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openLightbox(btn.querySelector('img'));
      });
    });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  if (reduced) {
    document.querySelectorAll('[data-bc-observe]').forEach(function (el) {
      el.classList.add('is-inview');
    });
    return;
  }

  if ('IntersectionObserver' in window) {
    var once = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-inview');
            once.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    document.querySelectorAll('[data-bc-observe]').forEach(function (el) {
      once.observe(el);
    });
  }

  // ---------- Giveaway floating button: reveal once the hero scrolls out of view ----------
  var giveawayBtn = document.querySelector('[data-bc-giveaway-float]');
  if (giveawayBtn) {
    var giveawayHero = document.querySelector('.bc-hero');

    if (giveawayHero && 'IntersectionObserver' in window) {
      var giveawayObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            giveawayBtn.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      giveawayObserver.observe(giveawayHero);
    } else {
      giveawayBtn.classList.add('is-visible');
    }

    giveawayBtn.addEventListener('click', function (e) {
      var href = giveawayBtn.getAttribute('href');
      if (!href || href === '#') {
        e.preventDefault();
        giveawayBtn.classList.toggle('is-label-active');
      }
    });
  }

  // ---------- Calendly floating button (Servicios): visible while scrolling
  // the page, hides once the real Calendly booking section comes into view. ----------
  var calendlyFloat = document.querySelector('[data-bc-calendly-float]');
  if (calendlyFloat) {
    var calendlySection = document.querySelector('.bc-calendly');

    if (calendlySection && 'IntersectionObserver' in window) {
      var calendlyObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            calendlyFloat.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      calendlyObserver.observe(calendlySection);
    } else {
      calendlyFloat.classList.add('is-visible');
    }
  }

  var heroMedia = document.querySelector('[data-bc-parallax]');
  if (heroMedia && window.innerWidth > 760) {
    var heroTicking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!heroTicking) {
          requestAnimationFrame(function () {
            var y = window.scrollY;
            heroMedia.style.transform = 'translateY(' + Math.min(y * 0.15, 120) + 'px)';
            heroTicking = false;
          });
          heroTicking = true;
        }
      },
      { passive: true, capture: true }
    );
  }
})();
